"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveOrganizationSlug = deriveOrganizationSlug;
/**
 * The canonical organization-slug rule, shared because both sides of the
 * screen depend on it agreeing.
 *
 * The backend creates the organization under it, so this decides the URL a client
 * actually gets. The invite form shows the same derivation as a preview while
 * staff type — and a preview that promises a URL we will not create is worse
 * than no preview. Two copies of a regex cannot be relied on to stay equal, so
 * there is one.
 */
function deriveOrganizationSlug(nameOrSlug) {
    return nameOrSlug
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^a-z0-9-]/g, "");
}
